import React from 'react';
import { CalendarClock } from 'lucide-react';
import { aud, fmtDate } from './utils';

const daysUntil = (iso) => Math.max(0, Math.ceil((new Date(iso) - new Date()) / 86400000));

const when = (iso) => {
  const d = daysUntil(iso);
  return d === 0 ? 'today' : d === 1 ? 'tomorrow' : `in ${d} days`;
};

export const DepositAlertList = ({ alerts }) => {
  if (!alerts.length) return null;
  return (
    <section className="space-y-3" data-testid="deposit-alert-section">
      <div className="flex items-center gap-2">
        <CalendarClock className="h-5 w-5 text-[#D9822B]" />
        <h2 className="font-heading text-xl font-semibold text-[#3A3530]">Deposit not paid · appointment within 7 days</h2>
        <span className="rounded-full bg-[#D9822B] px-2 py-0.5 text-xs font-bold text-white" data-testid="deposit-alert-count">{alerts.length}</span>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        {alerts.map((a) => (
          <div key={a.invoice_id} className="pp-glow-orange rounded-2xl border border-[#D9822B]/50 bg-[#FFF8EF] p-4" data-testid={`deposit-alert-card-${a.invoice_id}`}>
            <div className="flex items-start justify-between gap-3">
              <p className="truncate font-semibold text-[#3A3530]">{a.client_name}</p>
              <span className="whitespace-nowrap rounded-full bg-[#D9822B]/15 px-2 py-0.5 text-xs font-semibold text-[#A35A12]" data-testid={`deposit-alert-when-${a.invoice_id}`}>
                {when(a.next_appointment)}
              </span>
            </div>
            <p className="mt-0.5 text-sm font-medium text-[#A35A12]">
              Appointment {fmtDate(a.next_appointment, { weekday: 'short', day: '2-digit', month: 'short', hour: 'numeric', minute: '2-digit' })}
              {a.next_appointment_type ? ` · ${a.next_appointment_type}` : ''}
            </p>
            <p className="mt-1 text-xs text-[#6B6560]">
              Paid {aud(a.paid)} of {aud(a.deposit_required)} deposit · Invoiced {aud(a.invoiced)} · Invoice #{a.invoice_id}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};
